import React, { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";

/**
 * Reusable "Refine with AI" chat modal. Parent owns the target + thread and
 * handles the actual API call in onSend(text). Used by the Video Studio and
 * any other creative surface that wants conversational refinement.
 */
export default function RefineChat({ title = "Refine with AI", preview, thread = [], busy, placeholder, hint, onSend, onClose }) {
  const [input, setInput] = useState("");
  const send = () => {
    const text = input.trim();
    if (!text || busy) return;
    setInput("");
    onSend(text);
  };
  return (
    <div onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: "fixed", inset: 0, background: "rgba(11,36,71,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 }}
      data-testid="refine-modal">
      <div className="sr-card" style={{ maxWidth: 520, width: "100%", maxHeight: "88vh", display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <h3 style={{ fontSize: 17 }}><Sparkles size={16} style={{ verticalAlign: "-2px", color: "var(--gold)" }} /> {title}</h3>
          <button className="sr-btn sr-btn-ghost sr-btn-sm" onClick={onClose} data-testid="refine-close">Close</button>
        </div>
        {preview}
        <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: 8, minHeight: 80, marginBottom: 10 }} data-testid="refine-thread">
          {thread.length === 0 && <p className="sr-muted" style={{ fontSize: 13 }}>{hint || "Tell me what to change and I'll rework it."}</p>}
          {thread.map((m, i) => (
            <div key={i} style={{ alignSelf: m.role === "user" ? "flex-end" : "flex-start", maxWidth: "85%", background: m.role === "user" ? "var(--navy)" : "#EEF3FA", color: m.role === "user" ? "#fff" : "var(--navy)", borderRadius: 10, padding: "8px 10px", fontSize: 13 }}>
              {m.text}
            </div>
          ))}
          {busy && <div style={{ alignSelf: "flex-start", color: "var(--blue)", fontSize: 13 }}><Loader2 size={14} className="sr-spin" /> Applying…</div>}
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <input className="sr-input" style={{ flex: 1 }} value={input} onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter" && !busy) send(); }}
            placeholder={placeholder || "Describe the change…"} data-testid="refine-input" disabled={busy} />
          <button className="sr-btn sr-btn-primary" onClick={send} disabled={busy || !input.trim()} data-testid="refine-send">Send</button>
        </div>
      </div>
    </div>
  );
}
